import { gql, useQuery } from "@apollo/client";

import type { ICaaOrder, ICaaOrderQuery } from "@repo/shopify/queries/customer-account-gql";
import { caaOrderQuery } from "@repo/shopify/queries/customer-account-gql";

import apolloCaaClient from "@lib/apolloCaa";

interface IUseFindOrderCaaProps {
  orderId?: string;
}

interface IUseFindOrderCaaReturn {
  order: ICaaOrder | null;
  loading: boolean;
  orderNotFound: boolean;
}

// classic의 useFindOrder와 동일한 목적.
// root order(id) 쿼리로 단건 조회 (이전엔 CAA에 단건 조회가 없는 줄 알고 orders 목록을 250개씩
// 불러와 id로 찾았는데, 실제로는 있어서 교체 — 이 필드의 access scope가 orders 목록 조회에 쓰는
// customer_read_orders와 다르게 문서화되어 있어(customer_read_unauthenticated 등) 이 앱 OAuth 토큰으로
// 통과되는지 실 세션에서 검증 필요. 막히면 caaCustomerOrdersQuery + find 방식으로 되돌릴 것)
export default function useFindOrderCaa({ orderId }: IUseFindOrderCaaProps): IUseFindOrderCaaReturn {
  const { data, loading } = useQuery<ICaaOrderQuery>(gql(caaOrderQuery.query), {
    client: apolloCaaClient,
    variables: { id: orderId ? `gid://shopify/Order/${orderId}` : "" },
    skip: !orderId,
  });

  const order = data?.order ?? null;
  const orderNotFound = Boolean(orderId) && !loading && !order;

  return { order, loading, orderNotFound };
}
